// components/icons/CheckMark.jsx

const CheckMark = ({ className }) => (
	<svg 
		width="23" 
		height="20" 
		viewBox="0 0 23 20" 
		fill="none" 
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path 
			d="M3 11.1714L7.91111 16L20 3" 
			stroke="#09BD72" 
			strokeWidth="5" 
			strokeLinecap="round"
		/>
	</svg>
);

export default CheckMark;
